'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import * as PreviewerActions from 'DesignData/actions/Previewer';
const mapDispatchToProps = {
  savePreviewerWindow: PreviewerActions.savePreviewerWindow
};

class PreviewerAppLink extends PureComponent {
  constructor(...args) {
    super(...args);

    this.openPreviewer = () => {
      const {
        url,
        savePreviewerWindow
      } = this.props;
      savePreviewerWindow(window.open(url));
    };
  }

  render() {
    return /*#__PURE__*/_jsx(UIButton, {
      onClick: this.openPreviewer,
      rel: "noopener noreferrer",
      use: "secondary",
      size: "extra-small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "DesignEditorsUI.previews.livePreviewLink.label"
      })
    });
  }

}

PreviewerAppLink.propTypes = {
  url: PropTypes.string.isRequired,
  savePreviewerWindow: PropTypes.func
};
export default connect(null, mapDispatchToProps)(PreviewerAppLink);